module.exports = __webpack_public_path__ + "static/media/couple-sitting-under-tree.ad440f2b.jpg";